import React from 'react'
import ProvablySeedPair from '../../provably/elements/ProvablySeedPairs'
export default function Seeds({ pf, handleNotification }: any) {
  return (
    <ProvablySeedPair
      pf={pf}
      handleNotification={handleNotification}
      background={'#35353f'}
      size={'12px'}
      color={'#c4c9dd'}
      height={'10px'}
      padding={'5px'}
      marginBottom={'2px'}
    />
  )
}
